var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-2column",class:[
    {'is-preview-print': _vm.isPrintPreview},
    {'is-visible-login': _vm.group1.isFrontendLogin}
  ],attrs:{"id":"body"}},[(_vm.group1.isFrontendLogin)?_c('div',{staticClass:"login-bar"},[_c('span',[_vm._v("フロントエンドログイン中")]),_c('span',{staticClass:"ml12"},[_vm._v("事例ID: "+_vm._s(_vm.group1.qaCode))]),_c('span',{staticClass:"ml12"},[_vm._v("追録号数: "+_vm._s(_vm.group1.manualRecomentationDisp)+" ")])]):_vm._e(),_c('PCPrint'),_c('div',{attrs:{"id":"content"}},[(_vm.group1.type === 2)?[_c('iframe',{key:_vm.group1.pdfURLStatic,staticStyle:{"width":"100%"},style:({
          'height': 'calc(100vh)',
          'visibility':
          (!_vm.visibleMenu &&
          !_vm.common.systemError.show &&
          !_vm.common.notice.show)
          ? 'visible' : 'hidden'
          }),attrs:{"src":_vm.group1.pdfURLStatic,"frameborder":"0"}})]:_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }